export default __webpack_public_path__ + "static/media/home_image.f7e6036e.svg";